import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
	icon: {
		cursor: 'pointer',
		transform: 'scale(1)',
		transition: 'all .3s ease !important',
		marginLeft: '1rem',
		'&:hover': {
			transform: 'scale(1.05)'
		},
		'&:active': {
			transform: 'scale(1)'
		}
	}
}));
